import { Unit } from "types";
import { validateParams } from "../hookHelpers";
import { Options, useInfiniteCollection } from "../useInfiniteCollection";

export const useUnits = (queryParams: any = {}, options?: Options<Unit>) => {
    const params = validateParams(queryParams);

    const response = useInfiniteCollection<Unit>("units", params, options);

    return { ...response, units: response.data, isLoadingUnits: response.isLoading };
};
